import { gql } from '@apollo/client';

const messageThreads = gql`
  query MessageThreads {
    messageThreads {
      data {
        id
        job {
          id
        }
        canAcceptScout
        canPostMessage
        company {
          name
          logo
        }
        latestMessage {
          createdAt
          text
        }
        origin
      }
    }
  }
`;

const messageThread = gql`
  query MessageThread($id: ID!) {
    messageThread(id: $id) {
      origin
      company {
        name
        logo
      }
      job {
        id
      }
      canAcceptScout
      canPostMessage
      messages {
        id
        text
        kind
        createdAt
        jobSeeker {
          id
          image
          firstName
          lastName
        }
        companyStaff {
          id
          firstName
          lastName
          company {
            name
          }
        }
      }
    }
  }
`;

const postMessage = gql`
  mutation PostMessage($text: String!, $threadId: String!) {
    postMessage(text: $text, threadId: $threadId) {
      id
      messages {
        id
      }
    }
  }
`;

const acceptScout = gql`
  mutation AcceptScout($threadId: String!) {
    acceptScout(threadId: $threadId) {
      id
    }
  }
`;

export { messageThread, messageThreads, postMessage, acceptScout };
